import React from "react";
import { IoArrowUndoCircle } from "react-icons/io5";

import { useSelector, useDispatch } from "react-redux";
import {
  setVisible,
  setImage,
  setDescription,
  setTitle,
} from "../../../store/slices/kamasutra";

import KamaCard from "../gameCard";
import CustomModal from "../../modal";

export default function KamaListModal() {
  const dispatch = useDispatch();
  const { visible, image, description, title, number, hotLevel } = useSelector(
    (state) => state.kamasutra
  );

  const handleClose = () => {
    dispatch(setVisible(false));
  };

  const handleAfterClose = () => {
    dispatch(setImage(""));
    dispatch(setDescription(""));
    dispatch(setTitle(""));
  };

  return (
    <CustomModal
      visible={visible}
      handleClose={handleClose}
      handleAfterClose={handleAfterClose}
      className="w-full h-full pt-5 pb-5"
    >
      <div className="flex flex-col h-full">
        <button
          type="button"
          onClick={handleClose}
          className="mb-3 touchable-opacity"
        >
          <IoArrowUndoCircle color="white" size={42} />
        </button>
        <div className="flex justify-center items-center h-1/2">
          <KamaCard className="w-2/3 h-full" image={image} borderSize={25} />
        </div>
        <div>
          <h2 className="text-center mt-4 mb-4 font-bold text-xl leading-5">
            {title}
          </h2>
        </div>
        <div className="overflow-y-scroll scrollbar-hidden flex-1 mb-3">
          <p className="text-center text-lg">{description}</p>
        </div>
      </div>
    </CustomModal>
  );
}
